import { NumberRenderer } from '../../shared/numeralRenderers';
import {
  alignLeftCellStyle,
} from '@common/cellStyles';
import ProvisionQualitySingleLinkRenderer from './provisionQualitySingleLinkRenderer.component';
import { SPECIAL_TYPE_TOGGLE_MORE } from '../constants';

export default [
  {
    headerName: 'Business',
    field: 'businessCode',
    minWidth: 80,
    cellRenderer: ProvisionQualitySingleLinkRenderer,
    colSpan: params => params.data.type === SPECIAL_TYPE_TOGGLE_MORE ? 3 : 1,
    ...alignLeftCellStyle,
  },
  {
    cellRenderer: NumberRenderer,
    headerName: 'Provisions',
    field: 'readyToTax',
    minWidth: 64,
  },
  {
    headerName: 'Percentage Complete',
    field: 'successPercent',
    minWidth: 65,
    valueFormatter: ({ value }) => `${value}%`,
  },
];
